/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Toast_UpdatedInputs */

const he_notifications_toast_updated = /** @type {(inputs: Notifications_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההתראה עודכנה בהצלחה`)
};

const en_notifications_toast_updated = /** @type {(inputs: Notifications_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification updated`)
};

/**
* | output |
* | --- |
* | "Notification updated" |
*
* @param {Notifications_Toast_UpdatedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_toast_updated = /** @type {((inputs?: Notifications_Toast_UpdatedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Toast_UpdatedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_toast_updated(inputs)
	return en_notifications_toast_updated(inputs)
});